import React from "react";
import PropTypes from "prop-types";

const VideoPlayer = ({ videoId, title }) => {
  const videoSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&modestbranding=1&showinfo=0`;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        aspectRatio: "4 / 3",
        pointerEvents: "none"
      }}
    >
      <iframe
        src={videoSrc}
        title={title}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: "20px"
        }}
      ></iframe>
    </div>
  );
};

VideoPlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default VideoPlayer;

